module.exports = __webpack_public_path__ + "static/42-df9a03f6489efd8c2258fe22973ca5c9.png";